import { Fragment, useEffect, useState, createContext, useContext } from "react";
import { 
    Divider, 
    Chip, 
    Tooltip, 
    Typography ,
    ListItem,
    Stack,
    Checkbox,
    Button,
    ListItemText,
    ListItemIcon, 
    MenuItem,
    Link,
    Tab,
    Fab
} from "@mui/material";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { tss } from "tss-react";
//import { Scrollbars } from "react-custom-scrollbars";
import { useParams, useHistory } from "react-router-dom";
import ApiUtils from "api/Utils";
import { config } from "config";
import FoldersActions from "actions/FoldersAction";
import { sortArrayByProp, StorageUtils } from "services/UtilsService";
import EventsEmitter from "events/EventsEmitter";
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import CachedIcon from '@mui/icons-material/Cached';   
import CheckboxList from "panels/CheckboxList";
import ProjectItem from "components/ProjectItem";
import Pathfinder from "panels/Pathfinder";
import themeCfg from "config/theme.json";
//import CreateProjectPanel from "panels/CreateProjectPanel";
import UploadVersionPanel from "panels/UploadVersionPanel";
import ProcessDataPanel from "panels/ProcessDataPanel";
import MovePanel from "panels/MovePanel";
import ExportPanel from "panels/ExportPanel";
import ProjectSettingsPanel from "panels/ProjectSettingsPanel";
import NewFolderPanel from "panels/NewFolderPanel";
import DeleteItemsPanel, { DeleteItem } from "panels/DeleteItemsPanel";
import RenameItemPanel from "panels/RenameItemPanel";
import AddViewPanel from "panels/AddViewPanel";
import _ from 'utils/@lodash';
import { viewableEntitiesType, useVersioning } from "constants/common";
import { defaultViewProgram } from "constants/viewer";
import * as Utils from "services/UtilsService";
import { CircularProgressWithLabel } from "components";
import { getFileIcon } from "actions/GlobalActions";
import { getAccessLevel } from "actions/ViewerTools";
import useSwalWrapper from 'themes/jumbo/@jumbo/vendors/sweetalert2/hooks';
//icons
import { SortByAlpha, FilterList } from "@mui/icons-material";
import AddIcon from '@mui/icons-material/Add';
import SortIcon from '@mui/icons-material/Sort';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { icons } from "constants/viewer";
import NewVersionIcon from '@mui/icons-material/NewReleases';
import FolderIcon from '@mui/icons-material/Folder';
import TvIcon from '@mui/icons-material/Tv';
import EditNoteIcon from '@mui/icons-material/EditNote';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
//styles
import commonStyles, { folderColor, panelBackgroundColor } from "styles/common";
import viewsStyles from "styles/views";

//New projects module
import { useDispatch, useSelector } from 'react-redux';
import CreateProjectPanel from "panels/CreateProjectPanel/index";
import {
	openNewDialog,
    remoteDeleteProject
} from 'store/projects';
import { Div } from 'themes/jumbo/@jumbo/shared';
import { useJumboDialog } from 'themes/jumbo/@jumbo/components/JumboDialog/hooks/useJumboDialog';
import { StyledMenu } from 'themes/jumbo/app/_components/_core';
import { JumboCard } from 'themes/jumbo/@jumbo/components';

import NotificationModel from 'components/notificationPanel/model/NotificationModel';
import { addNotification } from 'components/notificationPanel/store/dataSlice';
import SubscriptionDialog from 'components/SubscriptionDialog';
import {
    setActiveProjectData,
    resetActiveProjectData
} from "store/auth";
import {AppContext} from "views/Loader";
import { trackEvent } from "components/Tracking";
import { addRawData } from "store/main/selectedRawData";

import { 
    openIndexedPointDialog,
    openDrillHoleDatabaseDialog,
    openGeoChemDialog,
    openVoxelTerrainDialog,
    openOrthoVoxelTerrainDialog,
    openVoxelizedMeshDialog,
    openIndexedMeshDialog,
    openVoxelBlockModelDialog,
    openIndexedImageryDialog
} from 'store/main/viewObjects';
import CustomScroll from "components/CustomScroll";
import { alpha } from '@mui/material/styles';

const useStyles = tss.create(() => ({
    root: {
        position: "relative",
        display: "inline-flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        height: "100%",
    },
    header: {
        flexDirection: "row",
        paddingLeft: 12,
        paddingTop: 12,
        width: "100%",
        alignItems: "center",
        verticalAlign: "top",
    },
    icon: {
        marginLeft: 25,
        cursor: "pointer",
    },
    row: {
        height: 30,
    },
    folderIcon: {
        width: 24,
        height: 34,
        marginRight: 10,
    },
    entitiesListButton: {
        marginTop: 0,
        fontSize: "0.8rem",
        paddingRight: 5,
        maxWidth: 220,
        textAlign: "left",
    },
    fluid: {
        flex: 1,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        minWidth: "50px",
        " & p ": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
    },
    iconEntity: {
        height: 24,
        width: 24,
        marginRight: 5,
        alignItems: "normal",
    },
    actionButton: {
        marginTop: 3,
        height: 30,
        color: "#28ABE3",
        justifyContent: "flex-start",
    },
    CircularProgress: {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto auto',
        width: 'unset',
        minWidth: '30px',
        minHeight: '30px',
    },
    sortPanel:{
        height:'120px',  
        justifyContent:'space-evenly',  
        cursor : 'default',
        //background: '#fff', 
        position:'absolute', 
        alignItems:'flex-end',
        top:'44px', 
        right:0, 
        display: 'flex', 
        flexDirection:'column', 
        zIndex:1,
        width:'138px',
        // borderTop: '1px solid rgba(0,0,0, 0.1)',
       // boxShadow: '0px 8px 10px #00000020, -10px 8px 15px #00000020, 10px 8px 15px #00000020'

    },
    sortItemContainer:{
        width: '100%',
        display:'flex',
        color: '#000',
        fontSize: '14px'
    },
    sortItemLabel:{
        textDecoration : 'none',
        background: 'transparent',
        cursor: 'pointer',
        width:'100%',
        border: 0,
        textAlign:'right',
        fontSize : '1rem'
    },
    sortLabel:{
        margin: "0 8px"
    },
}));

const getProductId = (catalog: any) => {
    if (catalog && catalog.entity && catalog.entity.workflow_product) {
        return catalog.entity.workflow_product;
    }
    return null;
};

const ProjectsListView = ({dataSource, filter}: {dataSource: any[]; filter: any}) => {
    const { 
        selectedItems,
        setSelectedItems,
        allItemsChecked,
        setAllItemsChecked,
        storeCachedData,
        hasFullAccess,
        hasProjectAccess,
        hasActiveSubscription,
        defaultProjects,
        onlyDefaultProjects,
        demoProjectsHidden, 
        setDemoProjectsHidden
    } = useContext<any>(CatalogContext);
    const { defaultTab } = useParams();
    const { classes, cx } = useStyles();
    const cachedData = storeCachedData.data;
    const [tabValue, setTabValue] = useState(defaultTab || 'myprojects');
    const [sortKey, setSortKey] = useState('date');
    const [sortOpened, setSortOpened] = useState(false)
    const [sortName, setSortName] = useState(false);
    const [sortDate, setSortDate] = useState(true);
    const [filteredProjects, setFilteredProjects] = useState<any[]>([]);
	const dispatch = useDispatch();

    const handleCheckboxClick = (e: any) => {
        const { value, checked } = e.target;
    
        if (checked && !defaultProjects.includes(value)) {
          setSelectedItems([...selectedItems, value]);
        } else {
          setSelectedItems(selectedItems.filter((item: any) => item != value));
        }
    };

    useEffect(() => {
        const projects = dataSource;
        console.log("My projects : " + JSON.stringify(projects))
        let resultArray : any = Object.values(projects);
        let projectsArray: any = Object.values(projects);
        projectsArray = (sortKey === 'name') ? sortArrayByProp(resultArray, "name", sortName) : sortArrayByProp(resultArray, "file_date", sortDate);
        setFilteredProjects(projectsArray);

    }, [sortKey, dataSource, sortName, sortDate])

    const sortAlpha = (val:any) => {
        setSortKey(val)
        console.log("Val : " + val)
        if(val === 'name')
            setSortName(!sortName);
        if(val === 'date')
            setSortDate(!sortDate);
    };

    const hideDemoProject = (e: any) => {
      const { checked } = e.target;
      setDemoProjectsHidden(checked);
    };

    const selectAllItems = (e: any) => {
      const { checked } = e.target;
      const collection: any[] = [];
  
      checked && filteredProjects.forEach((item) => {
        !defaultProjects.includes(item.ID) && collection.push(item.ID);
      })
  
      setSelectedItems(collection);
      setAllItemsChecked(checked);
    };

    const closeSortPanel = (e : any) => {
        const elem: any = document.getElementById('sortElem');
        if (!elem || !elem.contains(e.target))
            setSortOpened(false)
    }

    const deleteSelectedProjects = async (hideDialog: () => void, dispatch: any) => {
        //const cachedData = getCachedData();
        const projectsDispatchs: any[] = [];
        selectedItems.forEach((itemId: string) => {
            const item = FoldersActions.allEntities.find((entity: any) => entity.ID === itemId);
            if (!item) return;
            if (defaultProjects.includes(item.ID)) return; // if it's a default project we skip it
            const deletedProject = cachedData['projectsRef'].find(
                (projRef: any) => projRef['project_ref'] === itemId
            );
            deletedProject && projectsDispatchs.push(dispatch(remoteDeleteProject({ itemId, projectId: deletedProject['project'] })));
        });
        
        if (projectsDispatchs.length) {
            try {
                const results = await Promise.allSettled(projectsDispatchs);
                // Check if all promises were fulfilled successfully
                const allFulfilled = results.every((result) => result.status === 'fulfilled' && result?.value?.type !== 'projects/delete/rejected');
                FoldersActions.reloadCatalog(() => {
                    hideDialog();
                    if (allFulfilled) {
                        dispatch(addNotification(NotificationModel({ message: 'Selected items have been deleted successfully.', options: { variant: 'success' } })));
                        setSelectedItems([]);
                        setAllItemsChecked(false);
                        EventsEmitter.emit("reloadData", "");
                    } else {
                        dispatch(addNotification(NotificationModel({ message: 'One or more actions failed.', options: { variant: 'error' } })));
                    }
                });
                
                // EventsEmitter.emit("signalr_update", {
                //     type: "entity_update",
                //     action: "reload_all",
                // });
            } catch (error) {
			    dispatch(addNotification(NotificationModel({ message: 'Error deleting selected items.', options: { variant: 'error' } })));
            }
        }
    }

    const ProjectsListHeader = () => {
        const { showDialog, hideDialog } = useJumboDialog();
	    const dispatch = useDispatch();
    
        const handleBulkDelete = (e: any) => {
          showDialog({
            variant: 'confirm',
            title: 'Are you sure?',
            content: 'You won\'t be able to recover these projects later',
            onYes: () => {
                deleteSelectedProjects(hideDialog, dispatch);
            },
            onNo: hideDialog,
          });
        };
        const NewProjectBtn = (props: { onClick? : () => void}) => {
            const { onClick } = props;

            return (
                <Button
                    variant='contained'
                    style={{backgroundColor: '#3B82F7', color:'#fff'}} 
                    startIcon={<AddIcon fontSize="small"/>}
                    size={'small'}
                    id="btn-new-project"
                    onClick={(ev: any) => {
                        ev.stopPropagation();
                        trackEvent("Catalog", "Create Project", "Project Details")
                        !onClick && dispatch(openNewDialog(null));
                        onClick && onClick();
                    }}
                >
                    New Project
                </Button>
            );
        }
        const DeleteProjectsBtn = (props: { onClick? : () => void}) => {
            const { onClick } = props;

            return (
                <Button
                    variant='contained'
                    color={'error'}
                    disableElevation
                    size='small'
                    onClick={(ev: any) => {
                        ev.stopPropagation();
                        !onClick && handleBulkDelete(ev);
                        onClick && onClick();
                    }}
                >
                    <DeleteIcon sx={{width: 20, height: 20, mr: 1}} />
                    Delete
                </Button>
            );
        }
        return (
          <ListItem id="projects-header" component='div' sx={{backgroundColor: 'rgba(32, 32, 32,.03)', m: '0 25px', width: 'auto', mb: '15px', borderRadius: '12px', pr: '40px', pl: '20px'}}>
            <ListItemText
              sx={{ml: {xs: '-10px', sm: '-10px'}}}
              primary={
                <Stack direction={'row'} spacing={2}>
                    <Div sx={{padding: '0px 0 0 16px', display: 'flex', justifyContent: 'space-between', width: '100%', flexDirection: {xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row'}}}>
                        <Div sx={{display: 'flex', gap:  {lg: '35px'}, flexDirection: {xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row'}}}>
                            {!onlyDefaultProjects ? (
                                <label style={{display: 'flex', gap: '3px', alignItems: 'center', cursor: 'pointer'}}>
                                    <Checkbox
                                        color='primary'
                                        checked={allItemsChecked}
                                        onChange={selectAllItems}
                                        sx={{ml: {xs: '-10px', sm: '-10px'}}}
                                    />
                                    <Typography
                                        fontSize={'14px'}
                                        variant={'body1'}
                                        color={'text.secondary'}
                                    >
                                        Select All
                                    </Typography>
                                </label>
                            ) : ""}
                            <label style={{display: 'flex', gap: '3px', alignItems: 'center', cursor: 'pointer'}}>
                                <Checkbox
                                    color='primary'
                                    checked={demoProjectsHidden}
                                    onChange={(e) => {
                                        trackEvent("Catalog", "Demo projects", !demoProjectsHidden ? 'hide' : 'show');
                                        hideDemoProject(e);
                                    }}
                                    sx={{ml: {xs: '-10px', sm: '-10px'}}}
                                />
                                <Typography
                                    fontSize={'14px'}
                                    variant={'body1'}
                                    color={'text.secondary'}
                                >
                                    Hide Demo Projects
                                </Typography>
                            </label>
                        </Div>
                        <Div sx={{display: 'flex', gap: '15px', flexDirection: {xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row'}}}>
                            { selectedItems.length > 0 && !onlyDefaultProjects ? (
                                <div>
                                    { hasActiveSubscription ? <DeleteProjectsBtn /> : <SubscriptionDialog Component={DeleteProjectsBtn} /> }
                                </div>
                            ): ""}
                            <div>
                                { hasActiveSubscription ? <NewProjectBtn /> : <SubscriptionDialog Component={NewProjectBtn} /> }
                            </div>
                        </Div>
                    </Div>
                </Stack>
              }
            />
          </ListItem>
        );
    };
    /*const NewProjectBtn = (props: { onClick? : () => void}) => {
        const { onClick } = props;

        return (
            <Fab
                size='small'
                aria-label='New project'
                onClick={(ev: any) => {
                    ev.stopPropagation();
                    trackEvent("Catalog", "Projects", "Btn_Plus")
                    !onClick && dispatch(openNewDialog(null));
                    onClick && onClick();
                }}
                sx={{
                    color: 'common.white',
                    bgcolor: '#5AADE3',
                    //transform: 'scale(.85)',
                    '&:hover': {
                        bgcolor: '#2196f3',
                    },
                    ml: 'auto'
                }}
                >
                <AddIcon />
            </Fab>
        );
    }*/
    const NewProjectBtn = (props: { onClick? : () => void}) => {
        const { onClick } = props;

        return (
            <Button
                variant='contained'
                sx={{
                    color: 'common.white',
                    bgcolor: '#5AADE3',
                    //transform: 'scale(.85)',
                    '&:hover': {
                        bgcolor: '#2196f3',
                    },
                    ml: 'auto'
                }}
                startIcon={<AddIcon fontSize="small"/>}
                size={'small'}
                id="btn-new-project"
                onClick={(ev: any) => {
                    ev.stopPropagation();
                    trackEvent("Catalog", "Create Project", "Project Details")
                    !onClick && dispatch(openNewDialog(null));
                    onClick && onClick();
                }}
            >
                New Project
            </Button>
        );
    }
    return (
        <div className={classes.root} onClick={(e) => closeSortPanel(e)}>
            <TabContext value={tabValue}>
                <Div sx={{display:'flex', justifyContent:'space-between'}}>
                    <TabList
                        sx={{ borderColor: 'divider', mb: '40px' }}
                        onChange={(event, newValue) => setTabValue(newValue)}
                    >
                        <Tab
                            label={'MY PROJECTS'}
                            value={'myprojects'}
                            sx={{ minWidth: 200, fontSize: '16px' }}
                        />
                        <Tab label={'DEMOS'} value={'demos'} sx={{ minWidth: 200, fontSize: '16px' }} />
                    </TabList>
                    <Div style={{display:"flex", alignItems: 'center', marginLeft: 'auto'}}>
                        <div id="sortElem" style={{marginLeft: 'auto', position:'relative'}} >
                            <Button 
                                onClick={() => {
                                    trackEvent("projets", "Sort By", "Btn");
                                    setSortOpened(!sortOpened);
                                }} 
                                sx={{
                                    backgroundColor: (theme) => alpha(theme.palette.background.default, 0.75),
                                    color: (theme) => theme.palette.text.primary
                                }}
                                //style={{backgroundColor: '#fff', color:'#000'}} 
                                variant="contained" 
                                size="small"
                                startIcon={<SortIcon fontSize="small"/>} 
                                endIcon={sortOpened ? <KeyboardArrowUpIcon fontSize="small"/> : <KeyboardArrowDownIcon fontSize="small"/>}>
                                Sort By
                            </Button>
                            {
                            sortOpened ?
                            
                                <Div 
                                    className={classes.sortPanel} 
                                    id="sortPanel"
                                    sx={{
                                        backgroundColor: (theme) => alpha(theme.palette.background.default, 0.75),
                                        color: (theme) => theme.palette.text.primary
                                    }}
                                >
                                    {
                                    sortKey === 'name' ?
                                    <>
                                        <div className={classes.sortItemContainer} onClick={() => sortAlpha('name')}>
                                            {
                                            sortName ?
                                                <Button style={{color: themeCfg.sideTopColor}} fullWidth endIcon={<ArrowDownwardIcon style={{fontSize:'14px'}} /> }>Name</Button>
                                            :
                                                <Button style={{color: themeCfg.sideTopColor}} fullWidth endIcon={<ArrowUpwardIcon style={{fontSize:'14px'}} />}>Name</Button>
                                            }
                                        </div>
                                        
                                        <div className={classes.sortItemContainer} onClick={() => sortAlpha('date')}>
                                            <Button sx={{color: (theme) => theme.palette.text.primary}} fullWidth>Date</Button>
                                        </div> 
                                    </>
                                    :
                                    <>
                                        <div className={classes.sortItemContainer} onClick={() => sortAlpha('name')}>
                                            <Button sx={{color: (theme) => theme.palette.text.primary}} fullWidth>Name</Button>
                                        </div>
                                        <div className={classes.sortItemContainer} onClick={() => sortAlpha('date')}>
                                        {
                                            sortDate ?
                                                <Button style={{color: themeCfg.sideTopColor}} fullWidth endIcon={<ArrowDownwardIcon style={{fontSize:'15px'}} /> }>Date</Button>
                                            :
                                                <Button style={{color: themeCfg.sideTopColor}} fullWidth endIcon={<ArrowUpwardIcon style={{fontSize:'15px'}} />}>Date</Button>
                                        }
                                        </div>
                                    </>
                                    }
                                </Div> 
                                :""
                            }                   
                        </div>
                        <div style={{width:'15px'}}></div>
                        <div>{ hasFullAccess ? <NewProjectBtn /> : <SubscriptionDialog Component={NewProjectBtn} /> }</div>
                    </Div>
                </Div>
                <TabPanel value='myprojects' sx={{ p: 0, height: '100%' }}>
                    { /*<ProjectsListHeader />*/ }
                    <JumboCard
                        sx={{height: '100%', pt:'35px' }}
                    >
                        <CustomScroll
                            autoHeightMax={"100%"}
                            style={{ width: "100%", height: "calc(100% - 90px)", overflowX: "hidden"}}
                        >
                            <div>
                                {
                                    filteredProjects.length ? filteredProjects
                                        .filter((item:any) => !defaultProjects.includes(item.ID))
                                        .filter((item: any) => filter !== 'all' ? item.ID === filter : item.ID !== null)
                                            .map((item, index) => (
                                                <ProjectItem item={item} handleCheckboxClick={handleCheckboxClick} selectedItems={selectedItems} key={index} />
                                        )) : (
                                            <Typography
                                                fontSize={'18px'}
                                                variant={'body1'}
                                                color={'text.secondary'}
                                                sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '50px 0'}}
                                            >
                                                No project found
                                            </Typography>
                                    )
                                }
                            </div>
                        </CustomScroll>
                    </JumboCard>
                </TabPanel>
                <TabPanel value='demos' sx={{ p: 0, height: '100%' }}>
                    { /*<ProjectsListHeader />*/ }
                    <CustomScroll
                        autoHeightMax={"100%"}
                        style={{ width: "100%", height: "calc(100% - 90px)", overflowX: "hidden"}}
                    >
                        <div style={{padding: '0px 30px'}}>
                            {
                                filteredProjects.length ? filteredProjects.filter((item:any) => defaultProjects.includes(item.ID)).map((item, index) => (
                                    <ProjectItem item={item} handleCheckboxClick={handleCheckboxClick} selectedItems={selectedItems} key={index} />
                                )) : (
                                    <Typography
                                        fontSize={'18px'}
                                        variant={'body1'}
                                        color={'text.secondary'}
                                        sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '50px 0'}}
                                    >
                                        No demos found
                                    </Typography>
                                )
                            }
                        </div>
                    </CustomScroll>
                </TabPanel>
            </TabContext>
        </div>
    );
}

function MainPanel(props: { 
    catalogId: string;
    catalog: any;
    setCatalog: any;
    sort: boolean;
    selectedItems: any[];
    cacheLastUpdate: number;
    entities: any;
    loadEntities: boolean;
    //file_type: string;
}) {
    const { classes: viewsClasses } = viewsStyles();
    const { /*catalogId, catalog,*/ loadEntities, cacheLastUpdate } = props;
    const [filter, setFilter] = useState(Utils.StorageUtils.loadFromSessionStorage("filter") || "all");
    const [reload, setReload] = useState(false);
    //const data: any = getCachedData();

    const { 
        storeCachedData,
        catalog,
        catalogId,
        demoProjectsHidden, 
        defaultProjects
    } = useContext<any>(CatalogContext);
    var projects = storeCachedData.data["projects"];

    const { 
        tourActive,
        stepIndex,
        setRunTour,
        setStepIndex
    } = useContext<any>(AppContext);

    useEffect(() => {
        const timerId = setTimeout(() => {
            if(catalogId !== "0" || !tourActive) return;
        
            setRunTour(true);
            stepIndex !== 1 && setStepIndex(1);
        }, 2000);

        // Cleanup function
        return () => clearTimeout(timerId);
    }, [catalogId, tourActive, stepIndex]);

    useEffect(() => {
        var updateFilter = (filter: string) => {
            setFilter(filter);
            setReload(true);
        };
        EventsEmitter.on("updateFilter", updateFilter);
        return () => {
            EventsEmitter.removeEventListener("updateFilter", updateFilter);
        };
    }, []);
    
    const sortByDate = (a: any, b: any) => a.file_date && a.file_date > (b.file_date || '') ? -1 : 1;

    return catalog  ? (
        <div className={viewsClasses.main}>
            { catalogId !== "0" ?  (
                loadEntities ? <CheckboxList {...props} /> : ""
            ) : (
                <ProjectsListView 
                    dataSource={Object.values(projects)
                        //.filter((item: any) => (!demoProjectsHidden || !defaultProjects.includes(item.ID)))
                        //.filter((item: any) => filter !== 'all' ? item.ID === filter : item.ID !== null)
                        //.sort((a:any, b:any) => a?.name?.toLowerCase() > b?.name?.toLowerCase() ? 1 : -1)
                        .sort(sortByDate)
                    } 
                    filter={filter} 
                />
            )}
        </div>
    ) : "";
}

function SidePanel(props: {
    catalogId: string;
    catalog: any;
    selectedItems: any;
    createObject: (evt: any) => void;
    generatedEntities: any;
    access_level: string;
}) {
    const { catalogId } = props;
    return <div>{catalogId === "0" ? <SidePanelProject {...props} /> : <SidePanelFolder {...props} />}</div>;
}

const SidePanelMenuItem = ({ icon, label, onClick, disabled = false, id = "", textTransform = "uppercase" }: { icon?:React.ReactNode; label: string; onClick: (e: any) => void; disabled?: boolean; id?: string, textTransform?:string}) => {
    return (
      <MenuItem disabled={disabled} disableRipple sx={{ p: 0, mb: 2 }}>
        <Link underline={'none'} onClick={onClick} {...(id ? { id} : {})}>
          {icon && <ListItemIcon sx={{ color: 'inherit' }}>{icon}</ListItemIcon>}
          <ListItemText sx={{textTransform: textTransform, fontWeight: 600, fontSize:'13px'}}>{label}</ListItemText>
        </Link>
      </MenuItem>
    );
};


function SidePanelFolder(props: {
    catalog: any;
    createObject: (evt: any) => void;
    generatedEntities: any;
    access_level: string;
}) {
    const { classes } = useStyles();
    const { classes: viewsClasses } = viewsStyles();
    const { /*catalog, */createObject, generatedEntities, access_level } = props;
    const { classes: common } = commonStyles();
    const { 
        selectedItems,
        catalog,
        hasFullAccess,
        hasActiveSubscription,
        hasProjectAccess
    } = useContext<any>(CatalogContext);

    const history = useHistory();
    const dispatch = useDispatch();

    if (!catalog || catalog === null) {
        return (<div>problem</div>);
    }

    const fileType = catalog.file_type;

    console.log("File type : " + fileType)

    const entity: any = catalog["view_type"] ? catalog : FoldersActions.allEntities[catalog.ID];
    const project = catalog["project"];
    let allObjts : {type : string, name : string, id : string, project : string, file_folder : string}[] = [];

    //get all entities of the current project
    const allEntities: any = FoldersActions.allEntities.filter((entity: any) => entity["project"] === project);

    const keys = Object.keys(allEntities);
    keys.forEach((key, index)  => {
        if(allEntities[key]['type'] === 'FILE' || allEntities[key]['type'] === 'FOLDER'){
            //console.log("All entities : " + JSON.stringify(allEntities[key]))
            allObjts.push({type: allEntities[key]['file_type'], name: allEntities[key]['name'], id : allEntities[key]['ID'], project : allEntities[key]['project'], file_folder : allEntities[key]['file_folder']})
        }
    })

    const launchProcess = (objName:any, objType:any, id:any) => {

        switch (objName) {
           
            case 'Voxel Terrain':
                dispatch(addRawData([id]));
                history.push('/catalog/' + project)
                setTimeout(() => {
                      dispatch(openVoxelTerrainDialog({objName : objName, objType : objType, objSources : [...allObjts]}))
                }, 250);
                break;

            case 'Indexed Point':
                dispatch(addRawData([id]));
                history.push('/catalog/' + project)
                setTimeout(() => {
                    dispatch(openIndexedPointDialog({objName : objName, objType : objType, objSources : [...allObjts]}))
                }, 250);
                break;

             case 'Drill Hole Database':
                dispatch(addRawData([id]));
                history.push('/catalog/' + project)
                setTimeout(() => {
                    dispatch(openDrillHoleDatabaseDialog({objName : objName, objType : objType, objSources : [...allObjts]}))
                }, 250);
                break;

            case 'Geo Chem':
                dispatch(addRawData([id]));
                history.push('/catalog/' + project)
                setTimeout(() => {
                    dispatch(openGeoChemDialog({objName : objName, objType : objType, objSources : [...allObjts]}))
                }, 250);
                break;

             case 'Ortho Voxel Terrain':
                dispatch(addRawData([id]));
                history.push('/catalog/' + project)
                setTimeout(() => {
                    dispatch(openOrthoVoxelTerrainDialog({objName : objName, objType : objType, objSources : [...allObjts]}))
                }, 250);
                break;

             case 'Voxelized Mesh':
                dispatch(addRawData([id]));
                history.push('/catalog/' + project)
                setTimeout(() => {
                    dispatch(openVoxelizedMeshDialog({objName : objName, objType : objType, objSources : [...allObjts]}))
                }, 250);
                break;

            case 'Indexed Mesh':
                dispatch(addRawData([id]));
                history.push('/catalog/' + project)
                setTimeout(() => {
                    dispatch(openIndexedMeshDialog({objName : objName, objType : objType, objSources : [...allObjts]}))
                }, 250);
                break;

            case 'Voxel Block Model':
                dispatch(addRawData([id]));
                history.push('/catalog/' + project)
                setTimeout(() => {
                    dispatch(openVoxelBlockModelDialog({objName : objName, objType : objType, objSources : [...allObjts]}))
                }, 250);
                break;

            case 'Indexed Imagery':
                dispatch(addRawData([id]));
                history.push('/catalog/' + project)
                setTimeout(() => {
                    console.log('id : ' +id)
                    console.log('allObjts : ' + JSON.stringify(allObjts))
                    dispatch(openIndexedImageryDialog({objName : objName, objType : objType, objSources : [...allObjts]}))
                }, 250);
                break;

            default:
                console.log('Provide with a valid object name');
        }
    }



    const viewCatalog = (e: any) => {
        if (entity && entity.view_type === "container") {
            history.push({
                pathname: "/views/" + catalog.ID,
                state: {
                    from: window.location.pathname.replace("/app", ""),
                },
            });
            history.goForward();
        } else {
            let path;
            if (selectedItems.length === 0) {
                path = "/preview/" + catalog.ID;
            } else {
                path = "/preview/" + selectedItems.join("+");
            }
            history.push({
                pathname: path,
                state: {
                    from: window.location.pathname,
                },
            });
            history.goForward();
        }
    };

    const isViewable = () => {
        let viewable = false;
        const fileType = catalog.file_type;
        const viewType = catalog.view_type;
        const fileState = catalog.state;

        if (fileType && fileType === "IDXORTHO") {
            return viewable;
        }

        if(fileState && fileState !== 'COMPLETE'){
            return viewable;
        }

        if (selectedItems.length === 0) {
            viewable = viewableEntitiesType.includes(viewType) || Object.keys(defaultViewProgram).includes(fileType);
        } else {
            let prevView = true;
            selectedItems.forEach((catalogId: any) => {
                const catalog = FoldersActions.getCatalog(catalogId);
                if (catalog) {
                    const curViewable =
                        viewableEntitiesType.includes(catalog.view_type) || Object.keys(defaultViewProgram).includes(catalog.file_type);
                    viewable = curViewable && prevView;
                    prevView = viewable;
                }
            });
        }
        return viewable;
    };

    const goToFolder = (id: string) => {
        history.push({
            pathname: "/catalog/" + id,
            state: {
                from: window.location.pathname,
            },
        });
        history.goForward();
    };

    function getIcon(entity: any) {
        const fileTye = getFileIcon(entity);
        var Icon = icons[fileTye];
        if (!Icon) {
            Icon = icons["FILE"];
        }
        return <Icon className={classes.iconEntity} />;
    }

    const PROCESS_BY_FILETYPE = {
    RAWPC: [
        {label: 'To Indexed Points', process: 'Indexed Point' },
        { label: 'To Voxel Terrain', process: 'Voxel Terrain' },
    ],
    RAWMESH: [
        { label: 'To Indexed Mesh', process: 'Indexed Mesh' },
        { label: 'To Ortho Voxel Terrain', process: 'Ortho Voxel Terrain' },
        { label: 'To Voxelized Mesh', process: 'Voxelized Mesh' },
    ],
    RAWBM: [
        { label: 'To Voxel Block Model', process: 'Voxel Block Model' },
    ],
    ORTHO: [
        { label: 'To Indexed Imagery', process: 'Indexed Imagery' },
    ],
    RAWDH: [
        { label: 'To Drill Hole Database', process: 'Drill Hole Database' },
    ],
    RAWGEOCHEM: [
        { label: 'To Geo Chem', process: 'Geo Chem' },
    ],
    } as const;

    type ProcessableFileType = keyof typeof PROCESS_BY_FILETYPE;
    type FileType = ProcessableFileType | 'FOLDER';

    const isProcessableFileType = (
    type: FileType
    ): type is ProcessableFileType =>
    type in PROCESS_BY_FILETYPE;

 
    return (
        <div className={viewsClasses.side}>
            <div className={classes.header}>
                <StyledMenu sx={{ mb: 2 }}>
                    {fileType === "FOLDER" ? (
                        <div className={!hasFullAccess ? common.disabledEvents : ""}>
                            {catalog && catalog.entity && catalog.entity.workflow_product && (
                                <SidePanelMenuItem
                                    label="New Version"
                                    onClick={(e: any) => createObject("uploadVersion")}
                                    icon={<NewVersionIcon fontSize={'small'} /> }
                                    disabled={!hasFullAccess}
                                />
                            )}
                            <SidePanelMenuItem
                                label="New Folder"
                                onClick={() => createObject("newFolder")}
                                icon={<FolderIcon fontSize={'small'} /> }
                                disabled={!hasFullAccess}
                            />
                            <SidePanelMenuItem
                                label="Create View"
                                onClick={() => createObject("newView")}
                                icon={<TvIcon fontSize={'small'} /> }
                                disabled={!hasFullAccess}
                            />
                        </div>
                    ) : (
                        <div className={!hasFullAccess ? common.disabledEvents : ""}>
                            <SidePanelMenuItem
                                label="Rename"
                                onClick={() => createObject("renameItem")}
                                icon={<EditNoteIcon fontSize={'small'} /> }
                                disabled={!hasFullAccess}
                            />
                        </div>
                    )}
                    <span className={!hasFullAccess ? common.disabledEvents : ""}>
                        <SidePanelMenuItem
                            label="Move"
                            onClick={() => createObject("moveData")}
                            icon={<MoveUpIcon fontSize={'small'} /> }
                            disabled={!hasFullAccess || (fileType === "FOLDER" ? (selectedItems.length === 0 ? true : false) : false)}
                        />
                        { !(catalog.ID !== "0" && fileType !== "projects" && fileType !== "FOLDER") && (
                            <SidePanelMenuItem
                                label="Delete"
                                onClick={() => createObject("deleteItem")}
                                icon={<DeleteIcon fontSize={'small'} /> }
                                disabled={!hasFullAccess || (fileType === "FOLDER" ? (selectedItems.length === 0 ? true : false) : false)}
                            />
                            
                        )}
                        {
                        isProcessableFileType(fileType) && 
                            <>
                            <Divider />
                            <div style={{ margin: 10 }}></div>
                            </>
                        }                       
                        {
                        isProcessableFileType(fileType) &&
                            PROCESS_BY_FILETYPE[fileType].map(({ label, process }) => (
                                <SidePanelMenuItem
                                key={process}
                                label={label}
                                onClick={() => launchProcess(process, fileType, catalog.ID)}
                                icon={<CachedIcon fontSize="small" />}
                                disabled={!hasFullAccess}
                                textTransform="normal"
                                />
                        ))}
                       
                        
                    </span>
                    { isViewable() && (
                        <div>
                            <SidePanelMenuItem
                                label="Preview"
                                icon={<ViewInArIcon fontSize={'small'} /> }
                                onClick={viewCatalog}
                            />
                        </div>
                    )}
                    <Divider />
                    <div style={{ margin: 10 }}>
                        {catalog["user"] && (
                            <div>
                                <Typography variant="caption">Created by</Typography>
                                <Typography>{catalog["user"]}</Typography>
                            </div>
                        )}
                        {fileType === "FOLDER" && catalog["capture_date"] && (
                            <div style={{ marginTop: 10 }}>
                                <Typography variant="caption">Capture Date</Typography>
                                <Typography>{Utils.formatDateWithTime(catalog["capture_date"])}</Typography>
                            </div>
                        )}
                        {fileType !== "FOLDER" && catalog["file_date"] && (
                            <div style={{ marginTop: 10 }}>
                                <Typography variant="caption">Creation Date</Typography>
                                <Typography>{Utils.formatDateWithTime(catalog["file_date"])}</Typography>
                            </div>
                        )}
                        {catalog["version_active_date"] && (
                            <div style={{ marginTop: 10 }}>
                                <Typography variant="caption">Activation Date</Typography>
                                <Typography>{Utils.formatDateWithTime(catalog["version_active_date"])}</Typography>
                            </div>
                        )}
                        {catalog["comment"] && (
                            <div style={{ marginTop: 10 }}>
                                <Typography variant="caption">Comment</Typography>
                                <Typography>{catalog["comment"]}</Typography>
                            </div>
                        )}
                    </div>
                </StyledMenu>
            </div>
            {useVersioning && generatedEntities && generatedEntities.length > 0 && (
                <>
                    <Divider />
                    <div style={{ paddingLeft: 20, marginTop: 10, height: "calc(100% - 280px)" }}>
                        <Typography style={{ marginBottom: 5 }}>This version was built using:</Typography>
                        <CustomScroll autoHeightMax={"100%"} style={{ width: "100%", height: "100%", overflowX: "hidden" }}>
                            {generatedEntities.map((entity: any, index: number) => {
                                const workflow = FoldersActions.getWorkflow(entity);
                                return (
                                    <div
                                        style={{ marginTop: 5 }}
                                        onClick={() => {
                                            goToFolder(entity.ID);
                                        }}
                                        key={index}
                                    >
                                        <div className={common.middle} style={{ alignItems: "normal" }}>
                                            {getIcon(entity)}
                                            {workflow === null ? (
                                                <div>
                                                    <div>
                                                        <Button
                                                            color="primary"
                                                            className={classes.entitiesListButton}
                                                            onClick={() => {
                                                                goToFolder(entity.ID);
                                                            }}
                                                        >
                                                            {entity.name}
                                                        </Button>
                                                    </div>
                                                    <Chip label="Not Versioned" size="small" />
                                                </div>
                                            ) : (
                                                <div style={{ marginTop: -5 }}>
                                                    <Button
                                                        color="primary"
                                                        className={classes.entitiesListButton}
                                                        onClick={() => {
                                                            goToFolder(entity.ID);
                                                        }}
                                                    >
                                                        {entity.name}
                                                    </Button>
                                                    <Chip
                                                        label={workflow["version"]}
                                                        size="small"
                                                        style={{ backgroundColor: folderColor }}
                                                    />
                                                    <Tooltip title={workflow["products"].join(" - ")}>
                                                        <Chip
                                                            label={workflow["products"].join(" - ")}
                                                            size="small"
                                                            style={{ marginLeft: 3, marginBottom: 3, maxWidth: 220 }}
                                                        />
                                                    </Tooltip>
                                                    {entity.comment && (
                                                        <div>
                                                            <Typography variant="caption">{entity.comment}</Typography>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </CustomScroll>
                    </div>
                </>
            )}
        </div>
    );
}

function SidePanelProject(props: { catalogId: string; access_level: string; createObject: (evt: any) => void }) {
    const { classes, cx } = useStyles();
    const { classes: common } = commonStyles();
    const { classes: viewsClasses } = viewsStyles();
    var { createObject } = props;
	const dispatch = useDispatch();
    const { 
        selectedItems,
        hasActiveSubscription,
        sweetAlerts
    } = useContext<any>(CatalogContext);

    return (
        <div className={viewsClasses.side}>
            <StyledMenu sx={{ mb: 2 }}>
                <div className={!hasActiveSubscription ? cx(classes.header, common.disabledEvents) : ""}>
                    <SidePanelMenuItem
                        label="New Project"
                        onClick={(ev: any) => {
                            if (!hasActiveSubscription) {
                                sweetAlerts();
                                return;
                            }
                            ev.stopPropagation();
                            dispatch(openNewDialog(null));
                        }}
                        icon={<LibraryAddIcon fontSize={'small'} /> }
                        disabled={!hasActiveSubscription}
                        id="sidebar-new-project"
                    />
                    <SidePanelMenuItem
                        label="Delete Project"
                        onClick={() => createObject("deleteItem")}
                        icon={<DeleteIcon fontSize={'small'} /> }
                        disabled={!hasActiveSubscription || selectedItems.length < 1}
                    />
                </div>
            </StyledMenu>
        </div>
    );
}

function getDependencies(data: any, catalog: any, callback: any) {
    const dependencies: any = {};
    const project = catalog["project"];
    //get all entities of the current project
    const allEntities: any = FoldersActions.allEntities.filter((entity: any) => entity["project"] === project);

    const extractInputs = (updatesList: any) => {
        let pending = updatesList.length;

        !pending && callback([]);
        updatesList.forEach((object: any) => {
            const inputProperties = Object.getOwnPropertyNames(object).filter((prop: any) => {
                //limit values to guid only which is 32 characters in length
                return prop.includes("input_value_") && object[prop].length === 32;
            });
            inputProperties.forEach((inputId: string) => {
                // get the input value which is the entity id of the object
                const inputValue: string = object[inputId];
                const entry = allEntities.find(
                    (entity: any) =>
                        entity["ID"] === inputValue &&
                        entity["file_folder"] !== catalog["ID"] &&
                        entity["file_type"] &&
                        entity["file_type"] !== "FOLDER"
                );
                if (entry) {
                    const currentFolderId: string = entry["file_folder"];
                    const folderCatalog: any = allEntities.find((entity: any) => entity["ID"] === currentFolderId);
                    const entryCopy = { ...entry };
                    if (folderCatalog) {
                        entryCopy["comment"] = folderCatalog["comment"];
                    }
                    // to insure the avoidance of duplication
                    dependencies[inputValue] = entryCopy;
                }
            });
            pending--;
            if (pending === 0) {
                if (Object.keys(dependencies).length > 0) {
                    console.log("dependencies:", dependencies);
                }

                callback(Object.values(dependencies));
            }
        });
    };

    const catalogEntity: any = FoldersActions.getCatalogEntity(catalog);
    if (catalogEntity && catalogEntity["file_type"] === "FOLDER") {
        //get all virtuals of the current project
        const allVirtuals: any = Object.values(data["entities"][project]).filter(
            (entity: any) => entity["virtual"] === "1"
        );
        const files: any = catalog.files || [];
        let updatesList: any = files.filter(
            (object: any) => object["view_type"] !== "container" && object["file_type"]
        );
        const virtuals: any = allVirtuals.filter(
            (object: any) => object["file_folder"] === catalog["ID"] && object["file_type"] === "VIEW"
        );
        updatesList = updatesList.concat(virtuals);
        if (virtuals.length > 0) {
            console.log("virtuals:", virtuals);
        }
        const idsList: any = updatesList.map((entity: any) => {
            return entity["ID"];
        });
        if (Boolean(config.api.filters === "true")) {
            if (idsList.length === 0) {
                callback([]);
                return;
            }
            ApiUtils.getRemoteObjects(idsList, project, (updatesObject: any) => {
                extractInputs(updatesObject);
            });
        } else {
            extractInputs(updatesList);
        }
    } else {
        callback([]);
    }
}

export const CatalogContext = createContext({});

export default function Catalog() {
    const { classes: common } = commonStyles();
    const { classes, cx } = useStyles();
    const { classes: viewsClasses } = viewsStyles();
    var { catalogId:currentCatalogId } = useParams();
    const history = useHistory();
    //const data: any = getCachedData();

    const [loadData, setLoadData] = useState(false);
    const [reload, setReload] = useState(false);
    const [open, setOpen] = useState("");
    const [update, setUpdate] = useState(false);
    const [filter, setFilter] = useState(StorageUtils.loadFromSessionStorage("filter") || "all");
    const [catalog, setCatalog] = useState<any>(null);
    const [progress, setProgress] = useState(0);
    const items = FoldersActions.selectedItems;
    const [generatedEntities, setGeneratedEntities] = useState<any>([]);
    const [firstLoad, setFirstLoad] = useState(false);
    const [alphaSort, setAlphaSort] = useState(false);
    const [selectedItems, setSelectedItems] = useState<any[]>([]);
    const [allItemsChecked, setAllItemsChecked] = useState(false);
    const [cacheLastUpdate, setCacheLastUpdate] = useState(0);
	const storeCachedData = useSelector((state: any) => state.cache);
	const storeAuthData = useSelector((state: any) => state.auth);
    const [entities, setEntities] = useState<any[]>([]);
    const [loadEntities, setLoadEntities] = useState(false);
    const [catalogId, setCatalogId] = useState(currentCatalogId || '0');
    const { update:cacheUpdateTime, data } = storeCachedData;
    const [projects, setProjects] = useState<any>(null);
    const [type, setType] = useState('projects');
    const dispatch = useDispatch();
    const [hasFullAccess, setHasFullAccess] = useState(false);
    const [hasProjectAccess, setHasProjectAccess] = useState(false);
    const [onlyDefaultProjects, setOnlyDefaultProjects] = useState(false);
    const [demoProjectsHidden, setDemoProjectsHidden] = useState(Number(localStorage.getItem('hideDemoProjects') || 0) > 0);
    const { 
        hasActiveSubscription = false, 
        projectAccessLevel:access_level = "read", 
        activeProject, 
        mainProject, 
        isDefaultProject = false, 
        defaultProjects,
        storage_limit_exceeded,
        processtime_limit_exceeded
    } = storeAuthData;
	const storeProjectsData = useSelector((state: any) => state.projects);
    const { dialogBox } = storeProjectsData
    
    const Swal = useSwalWrapper();

    useEffect(() => {
        dialogBox.type === 'homenewproject' && dispatch(openNewDialog(null));
    }, [dialogBox.type])

    useEffect(() => {
        setHasProjectAccess(access_level === (!!activeProject ? 'full' : 'read'))
        setHasFullAccess(hasActiveSubscription && access_level === (!!activeProject ? 'full' : 'read'))
    }, [activeProject, access_level, hasActiveSubscription])

    useEffect(() => {
        localStorage.setItem('hideDemoProjects', demoProjectsHidden ? '1' : '0');
    }, [demoProjectsHidden])

    useEffect(() => {
        const _projects = JSON.parse(JSON.stringify(data.projects));
        if (_.isEqual(projects, _projects)) return;

        setProjects(_projects)
    }, [data.projects, projects])

    useEffect(() => {
        if (!projects) return;
        if (!catalog) return;
        const userProjects = Object.keys(projects).filter((item: string) => !defaultProjects.includes(item))
        setOnlyDefaultProjects(userProjects.length < 1 || (catalog['project'] && defaultProjects.includes(catalog['project'])));
    }, [projects, defaultProjects, catalog])

    useEffect(() => {
        if (currentCatalogId === catalogId) return;

        if (!currentCatalogId || currentCatalogId === "all") {
            setCatalogId('0');
            return;
        }
        setCatalogId(currentCatalogId);
    }, [currentCatalogId, catalogId])

    useEffect(() => {
        //if(cacheUpdateTime ===  cacheLastUpdate) return;
        setCacheLastUpdate(cacheUpdateTime);
        const _catalog = FoldersActions.getCatalog(currentCatalogId);
        
        if (!_catalog) return;
        const type = _catalog.ID === "0" ? "projects" : _catalog.file_type;
        setType(type);
        if (_.isEqual(_catalog, catalog)) return;
        setCatalog(_catalog);
        setLoadEntities(false);
    }, [cacheUpdateTime, catalogId, currentCatalogId, catalog])

    useEffect(() => {
        //if (currentCatalogId && currentCatalogId === catalogId && catalog) return;
        (!currentCatalogId || currentCatalogId === '0') && activeProject && dispatch(resetActiveProjectData());

        currentCatalogId && currentCatalogId !== '0' && (activeProject !== currentCatalogId || (catalog && mainProject !== catalog?.project)) && 
        dispatch(setActiveProjectData({
            activeProject: currentCatalogId,
            ...(catalog?.project ? {mainProject: catalog.project} : {}),
            projectAccessLevel: catalog?.project ? getAccessLevel(catalog?.project) : 'read'
        }));
    }, [catalogId, currentCatalogId, catalog, activeProject])

    useEffect(() => {
        if (!catalog) return;
        if (!cacheLastUpdate) return;
        setLoadEntities(true);
        const _cachedEntities = FoldersActions.listFolderItems(catalog, type);
        const cachedEntities = _cachedEntities?.filter((item: any) => !demoProjectsHidden || !defaultProjects.includes(item.ID)) 
        setEntities(cachedEntities);
        setFirstLoad(true);
        //setReload(true);
    }, [cacheLastUpdate, catalog, type])

    

    //const entities = FoldersActions.listFolderItems(catalog, type);

    useEffect(() => {
        if (catalogId === currentCatalogId) return;
        setAllItemsChecked(false);
        setSelectedItems([])
    }, [catalogId, currentCatalogId]);

    useEffect(() => {
        if (_.isEqual(FoldersActions.selectedItems, selectedItems)) return;
        FoldersActions.selectedItems =  [...selectedItems];
        setUpdate((prevUpdate) => !prevUpdate);
    }, [selectedItems, FoldersActions.selectedItems]);

    useEffect(() => {
        if (data.loaded && !reload) {
            if (FoldersActions.catalog === null) {
                var curCatalog = FoldersActions.getCatalog(catalogId);
                //console.log("****1.Catalog.curCatalog:", curCatalog);
                setCatalog(curCatalog);
                FoldersActions.catalog = curCatalog;
                setLoadData(data.loaded);
            }
        }
        // Remove reload to fix add object popup 2025-07-15
        if (data.loaded /*|| reload*/) {
            //console.log("catalog buildFolderTree...");
            FoldersActions.assigned = false;
            FoldersActions.buildFolderTree(filter, catalogId, () => {
                var curCatalog = FoldersActions.getCatalog(catalogId);
                //console.log("****2.Catalog.curCatalog:", curCatalog);
                setCatalog(curCatalog);
                //FoldersActions.catalog = curCatalog;
                setLoadData(true);
                setReload(false);
            });
        }
    }, [data, catalogId, filter, reload]);

    useEffect(() => {
        const updateFilter = (filter: string) => {
            setFilter(filter);
            setReload(true);
        };

        const reload = (event: any) => {
            if (
                data.loaded &&
                (catalogId === event["id"] || catalogId === event["folder"] || event["action"] === "reload_all")
            ) {
                console.log("Catalog.signalr.updateEvent:", event);
                setReload(true);
            }
        };

        const handleProgress = (curProgress: number) => {
            setProgress(curProgress);
        };

        const handleListBoxSelectedChange = (selectedItems: string[]) => {
            FoldersActions.selectedItems = selectedItems;
            setUpdate((prevUpdate) => !prevUpdate);
        };

        const reloadCatalog = () => {
            setReload(true);
        };

        EventsEmitter.on("reloadCatalog", reloadCatalog);
        EventsEmitter.on("updateFilter", updateFilter);
        //EventsEmitter.on("signalr_update", reload);
        EventsEmitter.on("updateCatalogList", handleListBoxSelectedChange);
        EventsEmitter.on("projects_progress", handleProgress);
        return () => {
            EventsEmitter.removeEventListener("reloadCatalog", reloadCatalog);
            EventsEmitter.removeEventListener("updateFilter", updateFilter);
            // EventsEmitter.removeEventListener("signalr_update", reload);
            EventsEmitter.removeEventListener("updateCatalogList", handleListBoxSelectedChange);
            EventsEmitter.removeEventListener("projects_progress", handleProgress);
        };
    }, [data, catalogId]);

    useEffect(() => {
        return () => {
            FoldersActions.catalog = null;
            FoldersActions.selectedItems = [];
        };
    }, []);

    useEffect(() => {
        if(currentCatalogId === catalogId) return;

        const catalog = FoldersActions.getCatalog(catalogId);
        setCatalog(catalog);
        return () => {
            setFirstLoad(false);
        };
    }, [catalogId, currentCatalogId]);

    //Get all entities used to generate results that are not part of this folder, to show on <SidePanelFolder>
    useEffect(() => {
        //console.log("firstLoad:", firstLoad, "|catalog:", catalog);
        if (data.loaded && catalog && catalog.ID && !firstLoad) {
            getDependencies(data, catalog, (generatedEntities: any) => {
                if (Array.isArray(generatedEntities)) {
                    generatedEntities = Utils.cleanArray(generatedEntities);
                    setGeneratedEntities(generatedEntities);
                }
                setFirstLoad(true);
            });
        }
    }, [data, catalog, firstLoad]);

    if (!data.loaded || !loadData || !catalog || !loadEntities) {
        return <CircularProgressWithLabel className={classes.CircularProgress} value={progress || 0} />;
    }

    const sweetAlerts = () => {
        Swal.fire({
        title: 'Your account has limited access!',
        text: 'We have limited your access to some features. Please upgrade your current plan to access this feature.',
        imageWidth: 450,
        imageHeight: 200,
        confirmButtonText: "Upgrade my plan",
        showCloseButton: true,
        }).then((result) => {
            result.isConfirmed && history.push("/profile");
        });
    };

    const createObject = (name: any) => {
        let state = isDefaultProject || !hasFullAccess;
        if( ['newFolder', 'newView'].includes(name)) {
            state = state || (processtime_limit_exceeded || storage_limit_exceeded);
            console.log("State : " + state)
            console.log('processtime_limit_exceeded : ' + processtime_limit_exceeded)
            console.log('storage_limit_exceeded : ' + storage_limit_exceeded)
        }
        if (state) {
            /*!hasFullAccess && */sweetAlerts();
            return;
        }
        setOpen(name);
    };

    const setProject = (projectId: string) => {
        var index = Object.keys(projects).findIndex((project: any) => project === projectId);
        if (index !== -1) {
            setUpdate((prevUpdate: boolean) => !prevUpdate);
            history.push("/catalog/" + projectId);
        }
    };
    const sortAlphabetic = () => {
        setAlphaSort((prevSort: boolean) => !prevSort);
    };

    const handleClose = () => {
        setOpen("");
        FoldersActions.assigned = false;
        FoldersActions.selectedItems = [];
    };
    const CatalogContextValue = {
        selectedItems,
        setSelectedItems,
        allItemsChecked,
        setAllItemsChecked,
        cacheLastUpdate,
        storeCachedData,
        catalogId,
        catalog,
        setCatalog,
        entities,
        setEntities,
        setReload,
        hasFullAccess,
        hasProjectAccess,
        hasActiveSubscription,
        isDefaultProject,
        defaultProjects,
        onlyDefaultProjects,
        sweetAlerts,
        demoProjectsHidden, 
        setDemoProjectsHidden,
        storage_limit_exceeded,
        processtime_limit_exceeded
    }

    return catalog && loadEntities ? (
        <CatalogContext.Provider value={CatalogContextValue}>
            <div className={viewsClasses.root} style={{ filter: update ? "none" : "none", marginTop:  catalogId !== "0" ? '0px' : '-30px' }}>
                { catalogId !== "0" && (
                    <div className={cx(common.middle, viewsClasses.topHeader)}>
                        <div style={{paddingLeft: catalogId === "0" ? '10px' : '0px'}}><Pathfinder /></div>
                        <div className={common.right}>
                            <FilterList style={{ display: "none" }} className={cx(classes.icon, common.disabledEvents)} />
                            <SortByAlpha
                                style={{ display: "none" }}
                                className={cx(classes.icon, common.disabledEvents)}
                                onClick={sortAlphabetic}
                            />
                        </div>
                    </div>
                )}
                <Div className={viewsClasses.content} sx={{flexDirection: {xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row'}}}>
                    <MainPanel 
                        catalogId={catalogId} 
                        catalog={catalog} 
                        setCatalog={setCatalog} 
                        entities={entities}
                        loadEntities={loadEntities}
                        sort={alphaSort} 
                        selectedItems={FoldersActions.selectedItems}
                        cacheLastUpdate={cacheLastUpdate}
                        //file_type={catalogId === "0" ? "projects" : catalog.file_type}
                    />
                    { catalogId !== "0" && (
                        <SidePanel
                            catalogId={catalogId}
                            catalog={catalog}
                            createObject={createObject}
                            selectedItems={FoldersActions.selectedItems}
                            generatedEntities={generatedEntities}
                            access_level={access_level}
                        />
                    )}
                </Div>
                {catalogId === "0" ? (
                    <Fragment>
                        {/*<CreateProjectPanel
                            open={open === "createProject"}
                            handleClose={handleClose}
                            setProject={setProject}
                        />*/}
                        <CreateProjectPanel />
                        <DeleteItemsPanel open={open === "deleteItem"} handleClose={handleClose} />
                    </Fragment>
                ) : (
                    <Fragment>
                        {open !== "" ? (
                            <div>
                                <UploadVersionPanel
                                    open={open === "uploadVersion"}
                                    handleClose={handleClose}
                                    product={getProductId(catalog)}
                                    project={catalog["project"]}
                                />
                                <ProcessDataPanel
                                    open={open === "processData"}
                                    handleClose={handleClose}
                                    catalogId={catalogId}
                                />
                                <NewFolderPanel open={open === "newFolder"} handleClose={handleClose} catalog={catalog} />
                                <RenameItemPanel open={open === "renameItem"} handleClose={handleClose} catalog={catalog} />
                                <DeleteItemsPanel open={open === "deleteItem"} handleClose={handleClose} />
                                {open === "newView" ? (
                                    <AddViewPanel
                                        handleClose={handleClose}
                                        folderId={catalog["ID"]}
                                        projectId={catalog["project"]}
                                    />
                                ) : (
                                    ""
                                )}
                                <MovePanel
                                    open={open === "moveData"}
                                    handleClose={handleClose}
                                    catalog={catalog}
                                    items={catalog?.file_type === "FOLDER" ? items : [catalogId]}
                                />
                                <ExportPanel open={open === "exportData"} handleClose={handleClose} catalogId={catalogId} />
                                <ProjectSettingsPanel
                                    open={open === "projectSettings"}
                                    handleClose={handleClose}
                                    catalogId={catalogId}
                                />
                            </div>
                        ) : (
                            ""
                        )}
                    </Fragment>
                )}
            </div>
        </CatalogContext.Provider>
    ) : "";
}
